import { useLocalization } from '~/composables/_next/useLocalization';
export default defineNuxtPlugin(function (nuxtApp) {
  var _useNuxt2App = useNuxt2App(),
    axeptioClientID = _useNuxt2App.$config.axeptioClientID;
  var _useLocalization = useLocalization(),
    locale = _useLocalization.locale;
  if (process.client) {
    window.axeptioSettings = {
      clientId: axeptioClientID,
      cookiesVersion: "az-main-".concat(locale),
      googleConsentMode: {
        default: {
          analytics_storage: 'denied',
          ad_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied',
          wait_for_update: 500
        }
      }
    };
    (function (d, s) {
      var t = d.getElementsByTagName(s)[0],
        e = d.createElement(s);
      e.async = true;
      e.src = '//static.axept.io/sdk.js';
      t.parentNode.insertBefore(e, t);
    })(document, 'script');
  }
});